import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { sb, User } from '../services/supabase';

const navItems = [
  { section: 'Platform', items: [
    { to: '/dashboard', icon: '📊', label: 'Dashboard' },
    { to: '/companies', icon: '🏢', label: 'Companies' },
    { to: '/users', icon: '👥', label: 'All Users' },
  ]},
  { section: 'Business', items: [
    { to: '/billing', icon: '💳', label: 'Billing & Plans' },
    { to: '/usage', icon: '📈', label: 'Usage Analytics' },
  ]},
  { section: 'System', items: [
    { to: '/activity', icon: '🔔', label: 'Activity Log' },
    { to: '/settings', icon: '⚙️', label: 'Settings' },
  ]},
];

export default function Sidebar({ user }: { user: User }) {
  const navigate = useNavigate();
  return (
    <aside style={{ background: 'var(--surface)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', padding: '24px 0', overflowY: 'auto', width: 240, flexShrink: 0 }}>
      <div style={{ padding: '0 20px 28px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid var(--border)', marginBottom: 20 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #00C9A7, #845EC2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>⏱</div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>ClockedIQ</div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 9, color: 'var(--accent)' }}>SUPER ADMIN</div>
        </div>
      </div>
      {navItems.map(section => (
        <div key={section.section} style={{ padding: '0 12px', marginBottom: 16 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', letterSpacing: 1, textTransform: 'uppercase', padding: '0 8px', marginBottom: 6 }}>{section.section}</div>
          {section.items.map(item => (
            <NavLink key={item.to} to={item.to} style={({ isActive }) => ({ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, fontSize: 14, fontWeight: 600, textDecoration: 'none', color: isActive ? 'var(--accent)' : 'var(--muted)', background: isActive ? '#00C9A715' : 'transparent', transition: 'all 0.15s' })}>
              <span style={{ fontSize: 16, width: 20, textAlign: 'center' }}>{item.icon}</span>{item.label}
            </NavLink>
          ))}
        </div>
      ))}
      <div style={{ marginTop: 'auto', padding: '16px 12px 0', borderTop: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px' }}>
          <div style={{ width: 34, height: 34, borderRadius: 10, background: 'linear-gradient(135deg, #00C9A7, #845EC2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 800, flexShrink: 0 }}>{user.full_name?.charAt(0) || 'R'}</div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700 }}>{user.full_name}</div>
            <div style={{ fontSize: 11, color: 'var(--accent)', fontFamily: 'var(--mono)' }}>platform_admin</div>
          </div>
        </div>
        <button onClick={async () => { await sb.auth.signOut(); navigate('/login'); }} style={{ width: '100%', marginTop: 8, background: 'transparent', border: '1px solid var(--border)', color: 'var(--muted)', borderRadius: 8, padding: 8, fontSize: 12, cursor: 'pointer', fontFamily: 'var(--font)' }}>← Sign Out</button>
      </div>
    </aside>
  );
}
